import React, { useState, useEffect } from 'react';
import { Row, Container, Col, Button, Table } from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import ExportVariantIcon from 'mdi-react/ExportVariantIcon';
import fileDownload from 'js-file-download';
import Api from '../../../util/api';
import t, { partial } from '../../../util/translation/translation';
import Loading from '../../../shared/components/custom/Loading';

import { Link } from 'react-router-dom';
import { formatDateTime } from '../../../util/date-and-time';

const QuestionaireCategoryLeaderboardPage = ({ categoryId, title }) => {
  const [leaderboardLoading, setLeaderboardLoading] = useState(false);

  const [leaderboard, setLeaderboard] = useState([]);

  const s = partial('shared');
  const qS = partial('question');
  const p = partial('questionaire');

  const getLeaderboard = async () => {
    setLeaderboardLoading(true);
    try {
      const leaderboardData =
        await Api.questionaire.getLeaderboardForCategory(categoryId);
      const { data: foundUsers } = await Api.users.getUsersByCloudIds(
        leaderboardData.items.map((item) => item.userId)
      );
      setLeaderboard(
        leaderboardData.items.map((item) => ({
          ...item,
          user: foundUsers.find((user) => user.userCloudId === item.userId),
        }))
      );
    } catch (error) {
      toast.error(s('somethingWentWrong'));
    } finally {
      setLeaderboardLoading(false);
    }
  };

  useEffect(() => {
    getLeaderboard();
  }, [categoryId]);

  const handleCSVExport = async () => {
    try {
      let csv = `${s('name')};${s('email')};${s('phone')};${p('score')};${p('answeredAt')}\n`;
      leaderboard
        .map((row) => [
          `${row.user.firstname} ${row.user.lastname}`,
          row.user.email,
          row.user.phoneNumber,
          row.score,
          moment(row.createdAt).format('MM-DD-YYYY HH:mm'),
        ])
        .forEach((row) => {
          csv += `${row.join(';')}\n`;
        });
      fileDownload(`\uFEFF${csv}`, `${title}.csv`);
    } catch (e) {
      console.error(e);
      toast.error(s('somethingWentWrong'));
    }
  };
  const renderLeaderboard = () => {
    return leaderboard.map((item, i) => {
      return (
        <tr
          style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
          key={`leaderboard-${item.id}`}
        >
          <td>
            <div className="flex-Vcenter">
              <Link to={`/users/edit/${item.userId}`}>
                {item.user.firstname} {item.user.lastname}
              </Link>
            </div>
          </td>
          <td>{item.score}</td>
          <td>{formatDateTime(item.createdAt)}</td>
        </tr>
      );
    });
  };
  return (
    <Container>
      <Loading loading={leaderboardLoading} />
      <Col className="mb-3">
        <Row>
          <div style={{ flex: 1 }} />
          <Button onClick={handleCSVExport} color="secondary" size="sm" outline>
            <ExportVariantIcon
              style={{
                height: '16px',
                marginTop: -2,
              }}
            />
            {qS('exportCSV')}
          </Button>
        </Row>
        <Row>
          <Container style={{ padding: 0 }}>
            <div
              style={{
                display: 'flex',
                paddingBottom: 5,
                background: '#fff',
                borderRadius: 6,
                boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
              }}
            >
              <Table responsive striped>
                <thead>
                  <tr>
                    <th style={{ color: '#4D576A' }}>
                      <div className="flex alignItems-center">{s('user')}</div>
                    </th>
                    <th style={{ color: '#4D576A' }}>
                      <div className="flex alignItems-center">{p('score')}</div>
                    </th>
                    <th style={{ color: '#4D576A' }}>
                      <div className="flex alignItems-center">
                        {p('answeredAt')}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>{renderLeaderboard()}</tbody>
              </Table>
            </div>
          </Container>
        </Row>
      </Col>
    </Container>
  );
};

export default QuestionaireCategoryLeaderboardPage;
